import { getRoutePath } from '@/routes/util';

import { ENudgeId, type INudgeConfig } from '../types';

/**
 * Nudge shown when a user has no drafts and navigates away from the drafts page.
 * Encourages them to create their first draft to kick off the onboarding flow.
 */
export const createFirstDraftNudge: INudgeConfig = {
  id: ENudgeId.CREATE_FIRST_DRAFT,
  titleKey: 'tours.nudge.createFirstDraft.title',
  descriptionKey: 'tours.nudge.createFirstDraft.description',
  actionLabelKey: 'tours.nudge.createFirstDraft.actionLabel',
  dismissLabelKey: 'tours.nudge.createFirstDraft.dismissLabel',
  namespace: 'tours',
  priority: 100,
  position: 'bottom-left',
  onAction: ({ dismiss, navigate, orgId, workspaceId }) => {
    dismiss();
    navigate(getRoutePath('DRAFTS', { orgId, workspaceId }));
  },
  analytics: {
    enabled: true,
    eventPrefix: 'nudge_create_first_draft',
  },
};
